import { useMediaQuery } from 'usehooks-ts';

import {
  type Breakpoint,
  BREAKPOINT_QUERIES,
} from '@/shared/constants/breakpoints';

/**
 * Hook that checks if the viewport matches a Tailwind breakpoint.
 *
 * @param breakpoint - The Tailwind breakpoint to check ('sm', 'md', 'lg', 'xl', '2xl')
 * @returns boolean - Whether the viewport is at or above the specified breakpoint
 *
 * @example
 * const isDesktop = useBreakpoint('lg');
 * const isTablet = useBreakpoint('md');
 */
export function useBreakpoint(breakpoint: Breakpoint): boolean {
  return useMediaQuery(BREAKPOINT_QUERIES[breakpoint]);
}
